import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Video, ExternalLink, Plus, Settings } from 'lucide-react';
import ReviewRecordLinksModal from '../../../../../components/ReviewRecordLinksModal/v3/ReviewRecordLinksModal';
import { Button } from '../../../../../components/ui/button';

function ReviewRecordLink({ reviewRecordLinks, updateReviewLinks }) {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  let normalizedLinks = [];
  if (Array.isArray(reviewRecordLinks)) {
    normalizedLinks = reviewRecordLinks;
  } else if (reviewRecordLinks) {
    normalizedLinks = [reviewRecordLinks];
  }

  const handleOnSaveModal = async (links) => {
    setIsLoading(true);
    try {
      await updateReviewLinks(links);
      setIsModalOpened(false);
    } catch (error) {
      console.error('Error saving links:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOnCloseModal = () => {
    setIsModalOpened(false);
  };

  const onOpenModal = () => {
    setIsModalOpened(true);
  };

  return (
    <>
      {normalizedLinks && normalizedLinks.length > 0 ? (
        <div className="flex flex-col items-start gap-1">
          {normalizedLinks.map((link) => (
            <a
              key={`record-${link}`}
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
            >
              <Video className="h-3 w-3" />
              <span>Record</span>
              <ExternalLink className="h-3 w-3" />
            </a>
          ))}
          <button
            type="button"
            onClick={onOpenModal}
            className="text-xs text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1"
          >
            <Settings className="h-3 w-3" />
            Manage
          </button>
        </div>
      ) : (
        <Button variant="ghost" size="sm" onClick={onOpenModal} className="h-7 text-xs">
          <Plus className="h-3 w-3 mr-1" />
          Add Record
        </Button>
      )}
      <ReviewRecordLinksModal
        links={normalizedLinks}
        isOpen={isModalOpened}
        onSave={handleOnSaveModal}
        onClose={handleOnCloseModal}
        isSaveLoading={isLoading}
      />
    </>
  );
}

ReviewRecordLink.propTypes = {
  reviewRecordLinks: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  updateReviewLinks: PropTypes.func.isRequired,
};

ReviewRecordLink.defaultProps = {
  reviewRecordLinks: null,
};

export default ReviewRecordLink;
